// First- and last-touch attribution in a first-party cookie, posted with every form so the
// stored lead keeps its gclid/utm values (needed later for Google Ads offline conversions).
const COOKIE_NAME = 'condor_lead_source';
const MAX_AGE_SECONDS = 90 * 24 * 60 * 60;
const MAX_VALUE_LENGTH = 200;
const URL_PARAMS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function readLeadSource() {
    const prefix = `${COOKIE_NAME}=`;
    const entry = document.cookie.split('; ').find((row) => row.startsWith(prefix));
    if (!entry) return null;

    try {
        return JSON.parse(decodeURIComponent(entry.slice(prefix.length)));
    } catch {
        return null;
    }
}

function externalReferrer() {
    if (!document.referrer) return '';
    try {
        return new URL(document.referrer).hostname !== window.location.hostname ? document.referrer : '';
    } catch {
        return '';
    }
}

// A visit counts as a new touch when it carries campaign parameters or arrives from another site.
function currentTouch() {
    const params = new URLSearchParams(window.location.search);
    const touch = {};

    for (const key of URL_PARAMS) {
        const value = params.get(key);
        if (value) touch[key] = value.slice(0, MAX_VALUE_LENGTH);
    }

    const referrer = externalReferrer();
    if (referrer) touch.referrer = referrer.slice(0, MAX_VALUE_LENGTH);

    return touch;
}

export default function initLeadSource() {
    const stored = readLeadSource() ?? {};
    const touch = currentTouch();
    const isNewTouch = Object.keys(touch).length > 0;

    if (stored.first && !isNewTouch) return;

    const stamped = {
        ...touch,
        landing_page: `${window.location.origin}${window.location.pathname}${window.location.search}`.slice(0, MAX_VALUE_LENGTH),
        date: new Date().toISOString(),
    };
    const next = {
        first: stored.first ?? stamped,
        last: isNewTouch || !stored.last ? stamped : stored.last,
    };
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(next))}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}
